import React, { useState } from 'react'

import type { CardType } from 'types/deck'

import { useCanEditDeck } from 'app-redux/deck/selectors'

import CategoryRow from './categoryRow'
import PhatButton from 'components/formElements/PhatButton'

import styles from './categories.module.scss'

type Props = {
  card: CardType
  onCardChange: (updatedCard: CardType) => void
  disabled?: boolean
}

// Category Selection list (the one where you can click the blue star)
const Categories = ({ card, onCardChange, disabled }: Props) => {
  const canEditDeck = useCanEditDeck()

  const handleCategoryChange = (updatedCard: CardType) => {
    setIsAdding(false)
    onCardChange({ ...updatedCard, qty: updatedCard.qty || 1 })
  }

  const [isAdding, setIsAdding] = useState(false)

  return (
    <div className={styles.container} key={card.id}>
      {card.categories.map((category, i) => (
        <CategoryRow
          key={i}
          card={card}
          category={category}
          primary={i === 0}
          onCardChange={handleCategoryChange}
          disableRemoveCategory={card.categories.length === 1}
          readOnly={!canEditDeck || disabled}
        />
      ))}
      {isAdding && (
        <CategoryRow
          onClose={() => setIsAdding(false)}
          card={card}
          category=""
          primary={false}
          onCardChange={handleCategoryChange}
          onDismissNewCategory={() => setIsAdding(false)}
          readOnly={!canEditDeck || disabled}
        />
      )}

      {canEditDeck && (
        <div className={styles.controls}>
          <PhatButton onClick={() => setIsAdding(true)} icon="plus" disabled={disabled}>
            Add Category
          </PhatButton>
        </div>
      )}
    </div>
  )
}

export default Categories
